














import Vue from "vue";
import { ref, Ref } from "@vue/composition-api";
import { UseModal } from "./modal.state";
import { UseDevice } from "@/common/state/device.state";
import { delay } from "@/utils/delay";
import { ModalResult } from "./modal-result.model";
export default Vue.extend({
  setup() {
    const { isMobile } = UseDevice();
    const { setRootModal } = UseModal();

    const isShow: Ref<boolean> = ref(false);
    const cmp: Ref<unknown | null> = ref(null);
    const modalData: Ref<unknown> = ref("");
    const z_index = ref(200);
    let sessionResolver: (result: ModalResult) => void = () => {
      /*  */
    };

    const transition_name = ref("fade");

    setRootModal({
      onShow: (zIndex, modalCmp: any, data?: any) => {
        console.log("Zindex", zIndex);
        z_index.value = zIndex;
        cmp.value = modalCmp;
        modalData.value = data;
        isShow.value = true;
        if (data && data.transition) {
          transition_name.value = data.transition;
        } else {
          transition_name.value = "fade";
        }

        return new Promise((resolve) => {
          sessionResolver = resolve;
        });
      },
      onHide: async () => {
        isShow.value = false;
        await delay(350);
      },
      onForceClose: async () => {
        onCancel();
      },
    });

    // ==== Modal callbacks ===
    const onSubmit = (msg?: string) =>
      sessionResolver({ type: "success", msg });
    const onCancel = () => {
      if (sessionResolver) {
        sessionResolver({ type: "canceled" });
      }
    };
    const onSwap = () => {
      sessionResolver({ type: "swap" });
    };

    const onError = (code: number) => {
      sessionResolver({ type: "error", code });
    };

    return {
      isShow,
      transition_name,
      isMobile,
      cmp,
      modalData,
      onSubmit,
      onCancel,
      onSwap,
      onError,
      z_index,
    };
  },
});
